export default {"src":"/_next/static/media/angelicaMia.19f0309f.svg","height":55,"width":49,"blurWidth":0,"blurHeight":0};